exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, ".overview-jumbotron{height:370px!important}.vl{border-left:1px solid #d8d8d8;height:100px}@media screen and (max-width:959px){.vl{height:0}.overview-jumbotron{height:540px!important}.phenolyzer-button-div{margin-top:30px}.hl{border-top:2px solid #d8d8d8;margin:auto;width:70%;margin-top:30px}}div.polaroid{width:400px;box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);text-align:center}.abc{border-radius:16px}#overview-panel center,#overview-panel h1,#overview-panel h2,#overview-panel h3,#overview-panel h4,#overview-panel span{font-family:Open Sans,sans-serif}#overview-panel h1,#overview-panel h4{color:#fff}#overview-panel h2,#overview-panel h3{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-656ea90e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=1!./client/app/components/pages/Overview.vue
// module id = 434
// module chunks = 0